export const rotasErro = [
  {
    path: "/403",
    name: "403",
    component: () => import("@/views/Error/403.vue"),
    meta: {
      showMenu: false,
    },
  },
  {
    path: "/ObraInacessivel",
    name: "ObraInacessivel",
    component: () => import("@/views/Error/ObraInacessivel.vue"),
    meta: {
      showMenu: false,
    },
  },
  {
    path: "/manutencao",
    name: "Manutencao",
    component: () => import("@/views/Error/Manutencao.vue"),
    meta: {
      showMenu: false,
    },
  },
  {
    path: "/404",
    name: "404",
    component: () => import("@/views/Error/404.vue"),
    title: "404",
    meta: {
      title: "404",
      showMenu: false,
    },
  },
];

// `component: 404` (numero, nao import) e `nome:` (nao `name:`) sao assim na
// origem: bug preexistente, preservado por R11 (PR de migracao nao muda
// comportamento) — o `redirect` abaixo garante que esse `component` nunca
// e de fato renderizado. Reportado, nao corrigido, nesta tarefa (T13).
export const rotaCatchAll = [
  {
    path: "/:pathMatch(.*)*",
    nome: "naoEncontrado",
    redirect: "/404",
    component: 404,
    title: "naoEncontrado",
    meta: {
      title: "naoEncontrado",
      showMenu: false,
    },
  },
];
